'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var Heap = require('heap');

var distance = require('xor-distance');

var debug = require('debug');

var utils = require('../utils');

var log = debug('libp2p:dht:peer-queue');
/**
 * PeerQueue is a heap that sorts its entries (PeerIds) by their
 * xor distance to the inital provided key.
 */

var PeerQueue = /*#__PURE__*/function () {
  _createClass(PeerQueue, null, [{
    key: "fromPeerId",

    /**
     * Create from a given peer id.
     *
     * @param {PeerId} id
     * @returns {Promise<PeerQueue>}
     */
    value: function () {
      var _fromPeerId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id) {
        var key;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return utils.convertPeerId(id);

              case 2:
                key = _context.sent;
                return _context.abrupt("return", new PeerQueue(key));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function fromPeerId(_x) {
        return _fromPeerId.apply(this, arguments);
      }

      return fromPeerId;
    }()
    /**
     * Create from a given buffer.
     *
     * @param {Buffer} keyBuffer
     * @returns {Promise<PeerQueue>}
     */

  }, {
    key: "fromKey",
    value: function () {
      var _fromKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(keyBuffer) {
        var key;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return utils.convertBuffer(keyBuffer);

              case 2:
                key = _context2.sent;
                return _context2.abrupt("return", new PeerQueue(key));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function fromKey(_x2) {
        return _fromKey.apply(this, arguments);
      }

      return fromKey;
    }()
    /**
     * Create a new PeerQueue.
     *
     * @param {Buffer} from - The sha2-256 encoded peer id
     */

  }]);

  function PeerQueue(from) {
    _classCallCheck(this, PeerQueue);

    log('create: %b', from);
    this.from = from;
    this.heap = new Heap(utils.xorCompare);
  }
  /**
   * Add a new PeerId to the queue.
   *
   * @param {PeerId} id
   * @returns {Promise}
   */


  _createClass(PeerQueue, [{
    key: "enqueue",
    value: function () {
      var _enqueue = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(id) {
        var key, el;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                log('enqueue %s', id.toB58String());
                _context3.next = 3;
                return utils.convertPeerId(id);

              case 3:
                key = _context3.sent;
                el = {
                  id: id,
                  distance: distance(this.from, key)
                };
                this.heap.push(el);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function enqueue(_x3) {
        return _enqueue.apply(this, arguments);
      }

      return enqueue;
    }()
    /**
     * Returns the closest peer to the `from` peer.
     *
     * @returns {PeerId}
     */

  }, {
    key: "dequeue",
    value: function dequeue() {
      var el = this.heap.pop();
      log('dequeue %s', el.id.toB58String());
      return el.id;
    }
  }, {
    key: "length",
    get: function get() {
      return this.heap.size();
    }
  }]);

  return PeerQueue;
}();

module.exports = PeerQueue;